import { RefObject, useEffect, useState } from 'react';

import { useOfferContext } from '../../../../context';
import { trackAutoZoom } from '../tracking';

interface IParams {
  cardRef: RefObject<HTMLDivElement>;
}

export const useAutoZoom = ({ cardRef }: IParams) => {
  const { jsonQuery, offer, position, isGalleryAutoZoomEnabled } = useOfferContext();

  const [isAutoZooming, setIsAutoZooming] = useState(false);

  useEffect(() => {
    if (isAutoZooming) {
      trackAutoZoom({ jsonQuery, offerId: offer.id, position });
    }
  }, [isAutoZooming, jsonQuery, offer.id, position]);

  useEffect(() => {
    const card = cardRef.current;
    const isActiveForEachFourthOffer = position % 4 === 0;

    if (!card || !isActiveForEachFourthOffer) {
      return () => {};
    }

    const handleMouseEnter = () => setIsAutoZooming(!!isGalleryAutoZoomEnabled);
    const handleMouseLeave = () => setIsAutoZooming(false);

    card.addEventListener('mouseenter', handleMouseEnter);
    card.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      card.removeEventListener('mouseenter', handleMouseEnter);
      card.removeEventListener('mouseleave', handleMouseLeave);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardRef]);

  return isAutoZooming;
};
